import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledPhoneConnectBox = styled.div`
   display: flex;
   gap: 16px;
   align-items: flex-start;
   padding: 16px;
   border-radius: 10px;
   background-color: ${(props) => props.theme.backgroundLightest};
`;

StyledPhoneConnectBox.displayName = 'StyledPhoneConnectBox';

export const StyledPhoneConnectQrCode = styled(StyledFlex)`
   width: 150px;
   height: 150px;
`;

StyledPhoneConnectQrCode.displayName = 'StyledPhoneConnectQrCode';
